module.exports = __webpack_public_path__ + "static/media/angular.7696d862.svg";